export default "__VITE_ASSET__BbpgLh2a__"